export default require('./SubscribeButton').default
